import { render, staticRenderFns } from "./PageNext.vue?vue&type=template&id=0349a996&"
import script from "./PageNext.vue?vue&type=script&lang=js&"
export * from "./PageNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports